import React from 'react';
import OtpInput from 'react-otp-input';
import PropTypes from 'prop-types';
import { Modal, Typography } from 'antd';
import PremiumButton from '../../premium/PremiumButton';
import Wrapper from './style';

const { Title, Paragraph } = Typography;

export default function PinModal(props) {
  const {
    showModal,
    hideModal,
    otp,
    setOtp,
    title,
    description,
    buttonLabel,
    isResendOtp,
    isResendPin,
    handleSubmit,
    loading,
    numInputs,
    resendOtp,
    setModalAction,
    setShowResendOtp,
    pinMode
  } = props;
  
  return (
    <Modal
      id='pin-modal'
      visible={showModal}
      closable={true}
      onCancel={() => hideModal(false)}
      footer={null}
      centered
      width={440}
      maskClosable={!pinMode}
      bodyStyle={{ padding: '40px' }}
    >
      <Wrapper>
        <div className='waya-modal-body center'>
          <Title level={4} className='modal-header-sub-data center'>
             {title || 'Verification Required'}
          </Title>

          <Paragraph className='modal-header-sub-data text-secondary'>
            {description}
          </Paragraph>

          <OtpInput
            value={otp}
            onChange={(val) => setOtp(val)}
            numInputs={numInputs}
            isInputSecure
            containerStyle='otp-cont'
            inputStyle='otp-input'
            shouldAutoFocus
          />

          <div className='w-100 mt-4 text-center'>
            <PremiumButton
              type='primary'
              loading={loading}
              disabled={loading || otp.length < numInputs}
              onClick={handleSubmit}
              block
              style={{ height: '48px' }}
            >
              {buttonLabel || 'Verify'}
            </PremiumButton>
          </div>

          {isResendOtp && (
            <div className='mt-4 text-center'>
              <a
                className='resend-link'
                onClick={(e) => {
                  e.preventDefault();
                  resendOtp(true);
                }}
                href='/#'
              >
                Resend Code
              </a>
            </div>
          )}

          {isResendPin && (
            <div className='mt-2 text-center'>
              <a
                href='/#'
                className='reset-link'
                onClick={(e) => {
                  e.preventDefault();
                  setModalAction('resetPin');
                  hideModal(false);
                  setShowResendOtp(true);
                }}
              >
                Reset Pin
              </a>
            </div>
          )}
        </div>
      </Wrapper>
    </Modal>
  );
}
PinModal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  hideModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  otp: PropTypes.string.isRequired,
  setOtp: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
  isResendOtp: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  numInputs: PropTypes.number,
  resendOtp: PropTypes.func,
  setModalAction: PropTypes.func,
  setShowResendOtp: PropTypes.func,
  pinMode: PropTypes.bool,
};
